var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FormRow',[_c('div',{staticClass:"col-sm-12"},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.siteKey,"loadRecaptchaScript":true},on:{"verify":_vm.onCaptchaVerified,"expired":_vm.onCaptchaExpired}})],1)]),(_vm.expireData.status)?_c('p',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.expireData.message))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }